import React from "react";
import { render } from "react-dom";
import DevView from "./dev";

import "@/style/animation.less";
import "@/style/font/font.less";
import "../index.less";

render(<DevView />, document.getElementById("root"));
